import type { IconData } from '@stacksjs/iconify-core'

export const basicUiExclamation: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h8l-2 10H6zm4 16a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiExclamation
